import { Link } from "react-router-dom";

export const authInput = "w-full border border-white/25 bg-white/[0.06] px-4 py-3.5 text-base text-white placeholder:text-zinc-500 outline-none transition-colors focus:border-[#E62314]";
export const authBtn = "flex w-full items-center justify-center gap-2 bg-[#E62314] px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-white hover:text-black disabled:opacity-50";

export const AuthShell = ({ title, subtitle, children, testId }) => (
  <div data-testid={testId} className="grain relative flex min-h-screen flex-col bg-[#0A0A0A] text-white">
    <div aria-hidden className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "repeating-linear-gradient(135deg, #fff 0 1px, transparent 1px 22px)" }} />
    <header className="relative px-5 py-5 sm:px-10">
      <Link to="/" className="inline-flex items-center gap-3" data-testid="auth-home-link">
        <img src="/assets/logo-dark.png" alt="Cresway Media logo" className="h-11 w-11 object-contain" />
        <span className="font-display text-lg font-extrabold tracking-tight">Cresway Media</span>
      </Link>
    </header>
    <main className="relative mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-5 pb-20 sm:px-0">
      <h1 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
      {subtitle && <p className="mt-3 text-sm text-zinc-300 sm:text-base">{subtitle}</p>}
      <div className="mt-8">{children}</div>
    </main>
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block"><span className="mb-2 block text-sm font-bold">{label}</span>{children}</label>
);
